export const PERF_WINDOW_VITAL_NAME = 'perf_window';
export const PERF_WINDOW_SAMPLING_VITAL_NAME = 'perf_window_sampling';
export const DEFAULT_WORKFLOW_PERF_WINDOW_DURATION_MS = 4_000;
// Maximum configured measurement length. A frame that starts before this limit
// and finishes afterward is counted in full, extending the reported duration.
export const MAX_PERF_OBSERVATION_DURATION_MS = 60_000;
// Frame-duration thresholds for the per-window severity counts.
export const NOTICEABLE_FRAME_DURATION_MS = 200;
export const SEVERE_FRAME_DURATION_MS = 500;
